import styled from "styled-components";

export const Container = styled.div`
    background: #fff;
    margin: 0 auto;
    max-width: 410px;
    padding: 2.5rem 2rem;

    @media(max-height: 700px) and (max-width: 860px) {
        padding-top: 0;
    }
`;

export const SubscribeHeading = styled.h2`
    margin-top: 0;
`;
export const SubscribeDiv= styled.div`
    display: none;
    @media(max-width: 490px) {
        display: block;
    }
`;


export const SubscribeLink = styled.a`
    border-radius: 8px;
    background: linear-gradient(to right, #FA578E, #FDA88E);
    color: #fff;
    display: block;
    text-align: center;
    font-size: 1.6rem;
    padding: 1.4rem;
    transition: all 200ms ease;

    
    &:hover {
        background: linear-gradient(to right, #fb89af, #fdb9a4);+
    }

    &:focus {
        outline: none;
    }

    &:active {
        transform: scale(0.9);
    }
`;